import React, { useEffect, useState } from 'react';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import axios from 'axios';

const Pollquestionform = () => {
  const [question, setQuestion] = useState('');
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [polls, setPolls] = useState([]);
  const [editPollId, setEditPollId] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);


  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      console.log('Stored User:', parsedUser);
    }
  }, []);



  const fetchPolls = async () => {
    try {
      const response = await fetch(`https://rvapi.emedha.in/pages/api/api/polls?user_id=${user.id}`);
      if (!response.ok) { throw new Error('Network response was not ok'); }
      const data = await response.json();
      console.log(data);
      setPolls(data);
    } catch (error) {
      setError('Error fetching polls: ' + error.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (user && user.id) {
      fetchPolls();
    } else {
      console.error('User ID not available');
    }
  }, [user]);


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!question || !option1 || !option2) {
      setError('Please fill out all fields');
      return;
    }

    const pollData = {
      question,
      options: [option1, option2],
      user_id: user.id,
    };

    if (editPollId) {
      fetch(`https://rvapi.emedha.in/pages/api/api/polls/${editPollId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pollData),
      })
        .then((response) => response.json())
        .then((data) => {
          const updatedPolls = polls.map((poll) =>
            poll.id === editPollId ? data : poll
          );
          setPolls(updatedPolls);
          setEditPollId(null);
          setQuestion('');
          setOption1('');
          setOption2('');
          setShowModal(false);
          fetchPolls();
        })
        .catch((error) => {
          setError('Error updating poll');
          console.error(error);
        });
    } else {
      fetch('https://rvapi.emedha.in/pages/api/api/polls', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pollData),
      })
        .then((response) => response.json())
        .then((data) => {
          setPolls([...polls, data]);
          setQuestion('');
          setOption1('');
          setOption2('');
          setShowModal(false);
          fetchPolls();
        })
        .catch((error) => {
          setError('Error creating poll');
          console.error(error);
        });
    }
  };


  const handleBack = () => {
    navigate(-1);
  };

  const handleDelete = (id) => {
    fetch(`https://rvapi.emedha.in/pages/api/api/polls/${id}`, {
      method: 'DELETE',
    })
      .then(() => {
        setPolls(polls.filter((poll) => poll.id !== id));
      })
      .catch((error) => console.error('Error deleting poll:', error));
  };

  const handleUpdate = (id) => {
    const pollToEdit = polls.find((poll) => poll.id === id);

    if (pollToEdit) {
      setEditPollId(id);
      setQuestion(pollToEdit.question);
      setOption1(pollToEdit.option1 || '');
      setOption2(pollToEdit.option2 || '');
      setShowModal(true);
    } else {
      console.error("Poll not found");
    }
  };

  const handleGenerateUrl = () => {
    const randomString = Math.random().toString(36).substring(2, 100);
    navigate(`/PollSelectForm/${user.id}/${randomString}/PollSelectForm`);
  };

  const [events, setEvents] = useState([]);
  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
    } else {
      console.log('No user data found in session storage');
    }
  }, []);
  useEffect(() => {
    if (user && user.id) {
      fetchEvents();
    } else {
      console.log('User is missing or incomplete');
    }
  }, [user]);

  const fetchEvents = async () => {
    if (!user || !user.id) {
      console.error('User ID is missing');
      return;
    }
    try {
      const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
      setEvents(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px' }}>
      <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', }}>
        <img src={events.find((event) => event.flag === 1)?.file || ''} alt="Logo" style={{ width: '100px', }} />
        <div style={{ flexGrow: 1, textAlign: 'center' }}>
          <h2 style={{ color: '#333', fontSize: '24px', fontWeight: '600', }} >
            {events && events.length > 0 ? events[0].name : 'No event available'}
          </h2>
        </div>
      </div>

      <div className='mt-2 mb-3' style={{ border: 'solid 2px black', borderRadius: '20px', padding: '10px' }}>
        <h1 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <IoArrowBackCircle onClick={handleBack} style={{ cursor: 'pointer' }} />
          Poll
          <button className="btn btn-primary btn-sm" onClick={(e) => { e.preventDefault(); setShowModal(true); }} style={{ borderRadius: '20px' }} >+ Add Poll</button>
          <button className="btn btn-primary btn-sm" onClick={handleGenerateUrl} style={{ borderRadius: '20px' }}>Generate Url</button>
        </h1>
      </div>


      {showModal && (
        <div className="modal fade show" style={{ display: 'block', position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: '9999', justifyContent: 'center', alignItems: 'center' }} tabIndex="-1">
          <div className="modal-dialog" style={{ maxWidth: '600px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create or Update Poll Question</h5>
                <button type="button" className="close" onClick={() => setShowModal(false)}>
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <label htmlFor="question">Poll Question:</label>
                    <input type="text" className="form-control" id="question" value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="Enter your question" />
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="option1">Option 1:</label>
                    <input type="text" className="form-control" id="option1" value={option1} onChange={(e) => setOption1(e.target.value)} placeholder="Enter option 1" />
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="option2">Option 2:</label>
                    <input type="text" className="form-control" id="option2" value={option2} onChange={(e) => setOption2(e.target.value)} placeholder="Enter option 2" />
                  </div>

                  {error && <p className="text-danger">{error}</p>}

                  <div className="d-flex justify-content-between">
                    <button type="submit" className="btn btn-success">Submit</button>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {polls.length > 0 && (
        <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffeeba', borderRadius: '5px', color: '#856404' }}>
          If you want to create a new poll, please delete existing data or update.
        </div>
      )}

      <div className="mt-4">
        <table className="table table-striped table-bordered table-responsive">
          <thead className="bg-success text-white">
            <tr>
              <th>#</th>
              <th>Question</th>
              <th>Option 1</th>
              <th>Option 2</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {polls.map((poll, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{poll.question}</td>
                <td>{poll.option1} - {poll.yes_count}</td>
                <td>{poll.option2} - {poll.no_count}</td>
                <td className="text-center">
                  <button className="btn btn-warning btn-sm" onClick={() => handleUpdate(poll.id)}><FaEdit /> </button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(poll.id)} style={{ marginLeft: '10px' }}><FaTrashAlt /> </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <footer style={{ position: 'fixed', left: '0', bottom: '0', width: '100%', padding: '20px 0', backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', zIndex: '1000', }}>
        <p>© 2025 Quizifyai. All rights reserved.</p>
      </footer>

    </div>
  );
};

export default Pollquestionform;
